import axios from "axios";

// Create an instance of Axios
const axiosInstance = axios.create();

// Add an interceptor to modify request data for every request
axiosInstance.interceptors.request.use((config: any) => {
    const reg_code = localStorage.getItem("reg_code") ?? "";
    const language = localStorage.getItem("appLanguage") || "en";

    // ✅ Add reg_code to URL
    config.url += config.url.includes("?") ? "&" : "?";
    config.url += `reg_code=${reg_code.trim()}`;

    // ✅ Add Accept-Language header
    config.headers = {
        ...config.headers,
        "Accept-Language": language
    };

    return config;
});

// clearing local storage and redirecting to login page
const handleRedirect = () => {
    // Do NOT wipe the session or bounce to the admin login when the user is in
    // the superadmin portal. Some superadmin pages (e.g. Member management) pull
    // reference data (roles / speciality / sites) from the admin API, where a
    // superadmin has no session; those 401s must not log the superadmin out.
    if (window.location.pathname.startsWith("/superadmin")) {
        return;
    }
    localStorage.clear();
    window.location.href = "/login";
};

// Intreceptor for checking every response
axiosInstance.interceptors.response.use(
    (response: any) => {
        //#76904 : To handle 401 error :this should be uncommented once dev server is deployed dashboard api's
        // if (response?.data?.status === 401) {
        //     handleRedirect();
        // } else {
        return response;
        // }
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            handleRedirect();
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
